import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import type * as fhirTypes from "fhir/r4";

interface CreateCarePlanResponse {
  carePlan: fhirTypes.CarePlan;
}

export const useCreateCarePlan = ({
  patientId,
  motherEncounterId,
  encounterId,
  isAmazon,
}: {
  patientId: string;
  motherEncounterId: string;
  encounterId: string;
  isAmazon: boolean;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<CreateCarePlanResponse, void>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.CREATE(patientId),
      mutationFn: () => {
        if (isAmazon) {
          return axiosInstance.post("/amazon-clinic/care-plans", {
            encounterId,
          });
        }
        return axiosInstance.post(
          `/charting/encounter-charting/${encounterId}/careplan`,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });

        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Timeline.ENCOUNTER({
            patientId,
            motherEncounterId,
            encounterId,
          }),
        });

        queryClient.invalidateQueries({
          queryKey: QueryKeys.Distribution.AVAILABLE_ACTIONS({
            patientId,
          }),
        });
      },
    },
  });
};
